import { Box, styled } from '@mui/material';

export const TableContainer = styled(Box)(({ theme }) => ({
  height: 'calc(100% - 53px)',
  overflowX: 'auto',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderRadius: '6px',
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledTable = styled('table')({
  borderCollapse: 'collapse',
  minWidth: '400px',
});

export const HeaderCell = styled('th')<{ isSticky?: boolean }>(({ isSticky, theme }) => ({
  padding: '8px 8px 0 16px',
  backgroundColor: theme.palette.background.paper,
  textAlign: 'left',
  fontWeight: 600,
  width: '200px',
  minWidth: '200px',
  '&:first-of-type': {
    width: '184px',
    backgroundColor: theme.palette.background.paper,
    textAlign: 'left',
    fontWeight: 500,
    position: 'sticky',
    left: 0,
    zIndex: 11,
    boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
  },
  ...(isSticky && {
    position: 'sticky',
    left: '199px',
    zIndex: 10,
    boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
  }),
}));

export const DataCell = styled('td')<{ isSticky?: boolean; isDragging?: boolean }>(
  ({ isSticky, isDragging, theme }) => ({
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    textAlign: 'left',
    verticalAlign: 'top',
    width: '200px',
    minWidth: '200px',
    ...(isDragging && {
      opacity: 0.5,
      backgroundColor: theme.palette.background.default,
    }),
    '&:first-of-type': {
      width: '184px',
      backgroundColor: theme.palette.background.paper,
      borderRight: '1px solid transparent',
      textAlign: 'left',
      fontWeight: 500,
      position: 'sticky',
      left: 0,
      zIndex: 10,
    },
    ...(isSticky && {
      position: 'sticky',
      left: '199px',
      zIndex: 9,
      boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
      backgroundColor: theme.palette.background.paper,
    }),
  })
);

export const AssetThumbnailContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'flex-start',
  gap: '8px',
  width: '164px',
});

export const DraggableRow = styled('tr')<{ isDragging?: boolean; isDragOver?: boolean }>(
  ({ isDragging, isDragOver, theme }) => ({
    ...(isDragging && {
      opacity: 0.5,
    }),
    ...(isDragOver && {
      backgroundColor: theme.palette.action.hover,
      borderTop: `2px solid ${theme.palette.info.main}`,
    }),
  })
);

export const DragHandle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  cursor: 'grab',
  '&:hover': {
    color: theme.palette.text.primary,
  },
  '&:active': {
    cursor: 'grabbing',
  },
}));

export const ThumbnailWrapper = styled(Box)(({ theme }) => ({
  width: '164px',
  height: '164px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
  overflow: 'hidden',
}));
